import {get_nested} from "../../../services/JsonHandler";
import {isNullOrUndefined} from "../../../services/Validator";
import ExerciserResultsScreen from "../../../screens/courses/exerciser/ExerciserResultsScreen";
import ExerciserTopBar from "../../bars/courses/exercisers/ExerciserTopBar";
import PreviewExerciserNotFoundError from "../../errors/previewScreen/PreviewExerciserNotFoundError";
import ExerciserContentMetaLayout from "../../layouts/courses/exercisers/ExerciserContentMetaLayout";
import ExerciserContentLayout from "../../layouts/courses/exercisers/ExerciserContentLayout";
import {activeExercisers} from "../../../constants/exercisers";

export default function PreviewExerciserManager({ identifier,
                                                  problem,
                                                  currentIndex,
                                                  isExerciserOver,
                                                  setIsExerciserOver,
                                                  setCurrentIndex }) {

    // PROPERTIES
    const activeExerciser = activeExercisers.find(
        (ex) => ex.id === Number(identifier)
    );
    const totalQuestions = get_nested(['questions'], problem, []).length

    // BUILD
    if (isNullOrUndefined(activeExerciser))
        return <PreviewExerciserNotFoundError />
    if (isExerciserOver)
        return <ExerciserResultsScreen isLeaveModalOpen={null}
                                       setIsLeaveModalOpen={null}
                                       onLeaveExerciserPressed={null}
                                       leaveExerciser={null}
                                       problem={problem}
                                       isSnackbarOpen={null}
                                       handleClose={null} />
    const Component = activeExerciser.component
    return (
        <div className="overflow-auto animate-appear grow h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** TOP BAR */}
            <ExerciserTopBar onLeaveFlashPressed={null}
                             currentIndex={currentIndex}
                             total={totalQuestions} />
            {/** CONTENT */}
            <ExerciserContentMetaLayout>
                <ExerciserContentLayout>
                    <Component problem={problem}
                               setIsExerciserOver={setIsExerciserOver}
                               currentIndex={currentIndex}
                               setCurrentIndex={setCurrentIndex} />
                </ExerciserContentLayout>
            </ExerciserContentMetaLayout>
        </div>
    )
}